module.exports = __webpack_public_path__ + "img/regionEducation_banner.af508f74.jpg";